export const despachosRoute: string = 'despachos';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/shared/data.service.ts
 **/